import { useQueries } from "@tanstack/react-query";
import { apiQueryAdapter } from "app/data/apiQueryAdapter";
import { QUERY_KEYS } from "app/data/common/queryKeys";

const findTerminalForSegment = (terminals: any[] = [], segment: string) => {
  const normalizedSegment = segment.trim().toUpperCase();
  if (!normalizedSegment) return null;

  return (
    terminals.find(
      (terminal) => terminal.airportCode?.toUpperCase() === normalizedSegment
    ) ??
    terminals.find((terminal) =>
      terminal.terminalName?.toUpperCase().includes(normalizedSegment)
    ) ??
    terminals.find((terminal) =>
      normalizedSegment.includes(terminal.airportCode?.toUpperCase() ?? "")
    ) ??
    null
  );
};

export const useTerminalDetailsByAirportCodes = (
  airportCodes: string[] = []
) => {
  const queries = useQueries({
    queries: airportCodes.map((airportCode) => ({
      queryKey: [QUERY_KEYS.GET_TERMINAL_DETAILS_BY_AIRPORT_CODE, airportCode],
      queryFn: async () => {
        const response = await apiQueryAdapter.query<{
          content?: any[];
        }>("/terminals", "GET", {
          params: {
            search: airportCode,
            page: 0,
            size: 50,
            terminalType: "XGS Terminal",
            physicalLocation: true,
          },
        });

        const terminal = findTerminalForSegment(
          response.data?.content ?? [],
          airportCode
        );

        if (!terminal) return null;

        return {
          segment: airportCode.toUpperCase(),
          terminal,
        };
      },
      enabled: !!airportCode,
      retry: false,
      refetchOnWindowFocus: false,
    })),
  });

  const isLoading = queries.some((query) => query.isLoading);

  const data = queries
    .map((query) => query.data)
    .filter(Boolean) as Array<{ segment: string; terminal: any }>;

  return {
    data,
    isLoading,
    queries,
  };
};
